export const getAbsoluteUrl = relativeUrl => {
  if (!getAbsoluteUrl._link) {
    getAbsoluteUrl._link = createUrlParser()
  }

  getAbsoluteUrl._link.href = relativeUrl

  return getAbsoluteUrl._link.href
}

export const createUrlParser = href => {
  const parser = document.createElement('a')
  if (href != null) {
    parser.href = href
  }
  return parser
}

export const appendQueryParams = (url, params) => {
  if (params === undefined) {
    return url
  }

  if (!appendQueryParams._link) {
    appendQueryParams._link = createUrlParser()
  }
  appendQueryParams._link.href = url

  const queryParams = new URLSearchParams(appendQueryParams._link.search)
  Object.keys(params).forEach(key => queryParams.append(key, params[key]))
  appendQueryParams._link.search = queryParams.toString()

  return appendQueryParams._link.href
}

export const setQueryParams = (url, params) => {
  if (params === undefined) {
    return url
  }

  if (!setQueryParams._link) {
    setQueryParams._link = createUrlParser()
  }
  setQueryParams._link.href = url

  const queryParams = new URLSearchParams(setQueryParams._link.search)
  Object.keys(params).forEach(key => {
    const value = params[key]
    if (value != null) {
      queryParams.set(key, params[key])
    } else {
      queryParams.delete(key)
    }
  })
  setQueryParams._link.search = queryParams.toString()

  return setQueryParams._link.href
}

export const getUrlOrigin = (url) => {
  if (!getUrlOrigin._link) {
    getUrlOrigin._link = createUrlParser()
  }

  getUrlOrigin._link.href = url

  return getUrlOrigin._link.origin
}
